import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

/** Strip all non-digit characters */
function digitsOnly(str) {
  return (str || '').replace(/\D/g, '');
}

/** Format raw digits (max 10) as +91 xxxxx xxxxx */
function formatDisplay(raw) {
  const d = digitsOnly(raw).slice(0, 10);
  if (!d) return '';
  if (d.length <= 5) return `+91 ${d}`;
  return `+91 ${d.slice(0, 5)} ${d.slice(5)}`;
}

/** Extract raw 10-digit number from any format */
export function phoneToRaw(val) {
  const d = digitsOnly(val);
  if (d.startsWith('91') && d.length > 10) return d.slice(2, 12);
  return d.slice(0, 10);
}

export const PhoneInput = forwardRef(({ value, onChange, className, ...props }, ref) => {
  // value stores raw digits (up to 10), display shows formatted
  const raw = digitsOnly(value).slice(0, 10);

  const handleChange = (e) => {
    const inputVal = e.target.value;
    // Extract only the digits after "+91 " prefix
    const afterPrefix = inputVal.startsWith('+91 ') ? inputVal.slice(4) : inputVal;
    const newDigits = digitsOnly(afterPrefix).slice(0, 10);
    onChange({ target: { value: newDigits } });
  };

  return (
    <input
      ref={ref}
      type="tel"
      inputMode="numeric"
      value={raw ? formatDisplay(raw) : ''}
      onChange={handleChange}
      placeholder="+91 xxxxx xxxxx"
      autoComplete="off"
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      {...props}
    />
  );
});

PhoneInput.displayName = 'PhoneInput';
